import { PickupType } from '../../shared/types.js';

export interface PickupSpriteVisual {
  url: string;
  width: number;
  height: number;
  yOffset?: number;
  tintStrength?: number;
  glowScale?: number;
}

export const PICKUP_SPRITE_VISUALS: Record<PickupType, PickupSpriteVisual> = {
  [PickupType.Drone]: {
    url: new URL('../assets/pickups/drone-pickup.png', import.meta.url).href,
    width: 5.0,
    height: 5.0,
    yOffset: 0.15,
    tintStrength: 0.18,
    glowScale: 1.18,
  },
  [PickupType.Algorithm]: {
    url: new URL('../assets/pickups/algorithm-pickup.png', import.meta.url).href,
    width: 4.8,
    height: 5.2,
    yOffset: 0.15,
    tintStrength: 0.16,
    glowScale: 1.16,
  },
};

export function getPickupSpriteVisual(pickupType: number): PickupSpriteVisual {
  return PICKUP_SPRITE_VISUALS[pickupType as PickupType] ?? PICKUP_SPRITE_VISUALS[PickupType.Drone];
}
